/**
 * Vue app for inline cross sells on product forms.
 *
 * Note: Vue library must be loaded before this script.
 *
 * @see form-inline-cross-sells.liquid
 */

(function () {
  var jsonElement = document.getElementById('inline-cross-sells-json');
  var json = jsonElement ? JSON.parse(jsonElement.innerHTML) : {};

  var variantCrossSells = json.variantCrossSells;
  var initialVariantKey = json.initialVariantKey;
  var initialVariantTitle = json.initialVariantTitle;
  var initialVariantSku = json.initialVariantSku;

  /**
   * Formats data for rendering for a single cross sell.
   */
  function formatCrossSell(crossSell, index) {
    var crossSellNumber = index + 1;
    var itemNumber = 'items[' + crossSellNumber + ']';
    return {
      enabled: false,
      label: crossSell.label,
      url: crossSell.url,
      price: crossSell.price,
      title: crossSell.title,
      number: index + 1,
      uniqueId: 'inline-cross-sell-' + crossSellNumber,
      idInputName: itemNumber + '[id]',
      idInputValue: crossSell.id,
      sourcePropName: itemNumber + '[properties][Included for]'
    }
  }

  /**
   * Filter callback to only show configure cross sells.
   */
  function filterCrossSell(crossSell) {
    return (crossSell.label && crossSell.title && crossSell.id && crossSell.url)
  }

  /**
   * Initializes the list of cross sells configured for a given variant.
   */
  function initCrossSells(variantKey) {
    var crossSells = variantCrossSells[variantKey] || [];
    return crossSells.filter(filterCrossSell).map(formatCrossSell)
  }

  // Vue.config.devtools = true;

  /**
   * Main Vue application.
   */
  new Vue({
    el: '#inline-cross-sells',
    delimiters: ['[[', ']]'],
    props: ['variantKey'],
    data: {
      sku: initialVariantSku,
      variantTitle: initialVariantTitle,
      variantKey: initialVariantKey,
      crossSells: initCrossSells(initialVariantKey)
    },
    mounted: function () {
      document.addEventListener('variant:changed', this.onVariantChange)
    },
    beforeDestroy: function () {
      document.removeEventListener('variant:changed', this.onVariantChange)
    },
    methods: {
      onVariantChange: function (event) {
        // Variant change could be fired outside this form (ie quick view).
        if (event.target.contains(this.$el)) {
          var variant = event.detail.variant;
          var variantKey = 'variant_' + (variant ? variant.id : 0);
          this.variantTitle = variant ? variant.title : "";
          this.variantKey = variantKey;
          this.crossSells = initCrossSells(variantKey);
          this.sku = variant ? variant.sku : "";
        }
      }
    }
  });

})();
